import FootballStatsCategory from "../../../../stats/football-stats-category";
import FootballState from "../../../../state/football-state";
import StatsRule from "../../../../../common/stats-rule";

export default class PuntReturnerStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.Returned &&
            [FootballState.Punt, FootballState.CflKick].some(
                (state) =>
                    state === play.getPreviousFragment(fragment).associatedState
            ) &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { puntedTo } =
            play.getPreceedingFragment(fragment, [
                FootballState.Punt,
                FootballState.CflKick
            ]) || {};

        const yards_returned =
            (fragment.returnedAt - puntedTo) *
            gameContext.getFieldDirectionMultiplier();

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: fragment.returnedBy.teamId,
            playerId: fragment.returnedBy.id,
            driveId: gameContext.currentDriveId,
            fragmentId: fragment.id,
            category: FootballStatsCategory.PUNT_RETURN,
            values: {
                completed: 1,
                attempted: 1,
                yards: yards_returned
            }
        });
    }
}
